<template>
  <q-card class="full-height">
    <q-card-section
      style="height: calc(100% - 52px)"
      class="bg-primary text-white"
      :class="{
        'bg-primary': team.status == 'active',
        'bg-blue-grey': team.status == 'draft',
        'bg-negative': team.scratched == 1 && fromWaves
      }"
    >
      <div
        v-if="team.status == 'active' || data.teamNamingFormat > 1"
        class="text-h6"
      >
        {{ team.team_name }}
        <q-icon
          v-if="team.status == 'active'"
          name="mdi-check-circle-outline"
          class="float-right"
        >
          <q-tooltip>
            This Team is currently active and is eligible for this event.
          </q-tooltip>
        </q-icon>
      </div>
      <div v-else class="text-h6">
        <q-input
          label="Team Name"
          v-model="team.team_name"
          v-bind="siteCFG.fields.general"
          @blur="saveTeamName(team.team_name)"
        >
        </q-input>
      </div>
      <div v-if="team.status == 'active'" class="text-subtitle2">
        <div
          v-for="(athlete, index2) in team.members"
          :key="`athlete_${index2}`"
        >
          {{ athlete.playerLabel }}: {{ athlete.firstName }}
          {{ athlete.lastName }}
        </div>
      </div>
      <div v-else class="row">
        <div
          v-for="(playerLabel, index) in JSON.parse(data.playerLabels)"
          :key="`athlete_${index}`"
          class="col-12 col-md-6"
        >
          <!-- {{ playerLabel }}; -->
          <assignMember
            :disable="
              currentUserData.role == 'Official' && athletes[playerLabel.name]
            "
            :id="athletes[playerLabel.name]"
            :label="
              `${playerLabel.name}${playerLabel.required == 1 ? ' *' : ''}`
            "
            :filterToEvent="data"
            :filterToPlayerLabel="playerLabel"
            :excludeIDList="excludedAthletes"
            :clearable="currentUserData.role != 'Official'"
            dark
            @changed="
              val =>
                updateMember(val, index, playerLabel.required, playerLabel.name)
            "
          />
        </div>
      </div>
    </q-card-section>
    <q-separator />
    <q-card-actions
      align="right"
      v-if="
        $route.path.includes('waves') ||
          ($moment() < $moment(competition.entriesCloseDate) &&
            data.currentStep == 0) ||
          data.entriesOpenOverride ||
          ['Admin', 'Sport Manager'].includes(currentUserData.role)
      "
    >
      <q-btn
        v-if="selectTeam && (team.scratched != 1 || !fromWaves)"
        flat
        no-caps
        @click="$emit('selectTeam', team)"
        style="position: absolute; left: 10px"
      >
        Select Team
      </q-btn>
      <q-btn
        v-else-if="fromWaves"
        flat
        no-caps
        @click="
          $emit('unscratchTeam', team);
          unscratchLoading = true;
        "
        style="position: absolute; left: 10px"
        :loading="unscratchLoading"
      >
        Un-scratch Team
      </q-btn>
      <q-btn
        v-if="team.status == 'active'"
        flat
        no-caps
        @click="changeStatusOfTeam(team.id, 'draft')"
      >
        Edit
      </q-btn>
      <q-btn
        v-if="team.status == 'draft'"
        flat
        no-caps
        :disable="requiredEntryCount < totalRequiredMembers"
        @click="changeStatusOfTeam(team.id, 'active')"
      >
        Submit Team
      </q-btn>
      <q-btn flat no-caps @click="removeFromEvent(team.id)"> Remove </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
import { mapGetters } from "vuex";
import assignMember from "@/components/users/assignMember.vue";
import teamManagementCard from "@/components/competitions/teamManagementCard.vue";

export default {
  components: { assignMember, teamManagementCard },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "events/current",
      dataLoading: "events/currentLoading",
      competition: "competitions/current",
      members: "associations/members",
      membersCurrentEvents: "associations/membersEnteredIndividualEvents",
      teams: "eventsEntries/teamList",
      teamsLoading: "eventsEntries/teamListLoading",
      association: "associations/current"
    })
  },
  props: {
    id: {
      default: null
    },
    team: {
      default: null
    },
    selectTeam: {
      type: Boolean,
      default: false
    },
    selectedTeam_id: {
      type: Number,
      default: null
    },
    fromWaves: {
      default: false,
      type: Boolean
    },
    selectedAssociation_id: {
      default: null,
      type: Number
    }
  },
  data: () => ({
    // Extra Data
    formData: {
      team_name: ""
    },

    athletes: {},
    enteringTeamLoading: false,
    requiredEntryCount: 0,
    totalRequiredMembers: 0,

    excludedAthletes: [],
    unscratchLoading: false
  }),
  watch: {
    teams: function() {
      this.updateExcludedAthletes();
    },
    team: function() {
      this.formData = {
        team_name: ""
      };
      this.athletes = {};
      this.requiredEntryCount = 0;
      this.totalRequiredMembers = 0;
      this.excludedAthletes = [];
      this.init();
      this.updateExcludedAthletes();
      this.$forceUpdate();
    }
  },
  beforeCreate() {},
  mounted() {
    this.init();
    this.updateExcludedAthletes();
  },
  methods: {
    updateExcludedAthletes() {
      this.excludedAthletes = [];
      this.teams.forEach(team => {
        team.members.forEach(member => {
          this.excludedAthletes.push(member.associationsMembers_id);
        });
      });
    },
    init() {
      this.totalRequiredMembers = JSON.parse(this.data.playerLabels).filter(
        pl => pl.required
      ).length;

      let playerLabels = JSON.parse(this.data.playerLabels);
      this.team.members.forEach(member => {
        let index = playerLabels.findIndex(pl => pl.name == member.playerLabel);

        if (
          !this.athletes[member.playerLabel] &&
          playerLabels[index].required == 1
        ) {
          this.requiredEntryCount += 1;
        }

        this.athletes[member.playerLabel] = member.associationsMembers_id;
        this.excludedAthletes.push(member.associationsMembers_id);
        this.$forceUpdate();
      });
    },

    saveTeamName() {
      this.$store
        .dispatch("eventsEntries/saveTeamName", {
          id: this.team.id,
          team_name: this.team.team_name
        })
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an error, please try again later"
            });
          }
          this.$store.dispatch("eventsEntries/loadAllTeamsForEvent", {
            id: this.id,
            association_id: this.fromWaves
              ? this.selectedAssociation_id
              : this.currentUserData.currentAssociation_id
          });
        });
    },

    updateMember(id, index, requiredEntry, playerLabel) {
      if (id) {
        if (!this.athletes[playerLabel] && requiredEntry == 1) {
          this.requiredEntryCount += 1;
        }
        this.athletes[playerLabel] = id;
        this.excludedAthletes.push(id);
      } else {
        delete this.athletes[playerLabel];
        if (requiredEntry == 1) {
          this.requiredEntryCount -= 1;
        }
        this.excludedAthletes.filter(x => x != id);
      }
      this.$forceUpdate();

      let payload = {
        team_id: this.team.id,
        associationsMembers_id: id,
        playerLabel: playerLabel,
        index: index
      };
      this.$store
        .dispatch("eventsEntries/changeMemberInTeam", payload)
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an error, please try again later"
            });
          }
          this.$store.dispatch("eventsEntries/loadAllTeamsForEvent", {
            id: this.id,
            association_id: this.fromWaves
              ? this.selectedAssociation_id
              : this.currentUserData.currentAssociation_id
          });
        });
    },
    removeFromEvent(id) {
      let payload = {
        id: id,
        events_id: this.$route.params.events_id
      };
      // console.log(payload);
      this.$store
        .dispatch("eventsEntries/removeTeamFromEvent", payload)
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an error, please try again later"
            });
          }
          this.$store.dispatch("eventsEntries/loadAllTeamsForEvent", {
            id: this.id,
            association_id: this.fromWaves
              ? this.selectedAssociation_id
              : this.currentUserData.currentAssociation_id
          });
        });
    },
    changeStatusOfTeam(id, status) {
      let payload = {
        id: id,
        status: status
      };

      this.$store
        .dispatch("eventsEntries/changeTeamStatus", payload)
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an error, please try again later"
            });
          }
          console.log(this.selectedAssociation_id);
          this.$store.dispatch("eventsEntries/loadAllTeamsForEvent", {
            id: this.id,
            association_id: this.fromWaves
              ? this.selectedAssociation_id
              : this.currentUserData.currentAssociation_id
          });
        });
    },
    removeMemberFromTeam(id) {
      let payload = {
        id: id,
        events_id: this.$route.params.events_id
      };

      this.$store
        .dispatch("eventsEntries/removeMemberFromTeam", payload)
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an error, please try again later"
            });
          }
          this.$store.dispatch("eventsEntries/loadAllTeamsForEvent", {
            id: this.id,
            association_id: this.fromWaves
              ? this.selectedAssociation_id
              : this.currentUserData.currentAssociation_id
          });
        });
    }
  }
};
</script>
